<template>
    <div :style="error?'border: 2px solid rgba(220, 11, 11, 0.898);border-radius: 5px; padding: 5px;' : 'border: 1px solid gray; border-radius: 5px; padding: 5px;' ">
      <!-- Choices{{myChoices}}
      SelectedPath {{selectedPath}} -->
        <v-row v-if="!error">
            <v-col cols="12">
                <div style="display: flex; align-items: center; gap: 3px;" v-if="!hardcode_mode && !manual_mode">
                    <div v-for="(choice, index) in selectedPath" :key="index" style="display: flex; align-items: center;">
                        <!-- Show the selected path segment -->
                        <div v-if="choice != '' && index !== currentDepth">
                        {{choice}} <template v-if="index < selectedPathWithoutEmpty.length - 1">.</template>
                        </div>
                
                        <!-- Show the dropdown for the current depth -->
                        <div v-else-if="myChoices.length > 0">
                        <v-select
                            v-model="selectedPath[currentDepth]"
                            outlined
                            @change="selected_route"
                            :items="myChoices"
                            dense
                            style="min-width: 120px; max-width: 120px;height: 32px;margin:0px"
                        ></v-select>
                        </div>
                    </div>
                    <v-btn v-if="currentDepth>0" @click="clear_last" color="primary" icon>
                        <v-icon>mdi-arrow-left</v-icon>
                    </v-btn>
                </div>
                <div v-else style="display: flex; align-items: center; gap: 3px;">
                    <v-text-field
                        v-model="hardcoded_value"
                        outlined
                        dense
                        @input="update_value"
                        style="min-width: 120px; max-width: 200px;height: 32px;margin:0px"
                    ></v-text-field>
                    <v-btn @click="clear_all" color="primary" icon>
                        <v-icon> mdi-delete</v-icon>
                    </v-btn>
                </div>
            </v-col>
        </v-row>
        <v-row v-else>
            <v-col cols="9">
                <div style="display: flex; align-items: center; gap: 2px;">
                    <div v-for="(choice, index) in selectedPathWithoutEmpty" :key="index" style="display: flex; align-items: center;">
                        <!-- Show the selected path segment -->
                        <p v-if="error !== choice">
                        {{choice}}
                        </p>
                        <p v-else style="color:red">
                            {{choice}}
                        </p>
                        <p v-if="index < selectedPathWithoutEmpty.length - 1">
                        .
                        </p>
                    </div>
                </div>
            </v-col>
            <v-col cols="3">
                <v-btn @click="clear_all" color="primary" icon>
                    <v-icon> mdi-delete</v-icon>
                </v-btn>
            </v-col>
        </v-row>
    </div>
</template>
<script>
export default {
  name: "RouteInBagSelectorComponent",
  props: {
    my_bag: {
      type: Object,
      required: true,
    },
    value: {
      type: String,
      required: true,
    },
    outlined: {
      type: Boolean,
      default: true,
    },
    allow_hardcoding: {
      type: Boolean,
      default: true,
    },
  },
  data() {
    return {
      selectedPath: [], 
      hardcoded_value: "", 
    };
  },
  computed: {
    selectedPathWithoutEmpty(){
        return this.selectedPath.filter( (val) => val != "");
    },
    myChoices() {
        if (!this.error){
            let res = []
            let value = this.my_bag;
            for(let key of this.selectedPath){
                if (key == ""){
                    break;
                }
                value = value[key];
            }
            if (Array.isArray(value)){
                res = [];
            }
            else if (value && typeof value == "object"){
                res = Object.keys(value);
            }
            if (this.currentDepth == 0 && this.allow_hardcoding){
                res.push("VALOR FIJO");
            }
            if (this.currentDepth == 0 && this.allow_hardcoding){
                res.push("RUTA MANUAL");
            }
            return res;
        }
    },
    list_ahead() {
        if (!this.error){
            let value = this.my_bag;
            for(let key of this.selectedPath){
                if (key == ""){
                    break;
                }
                value = value[key];
            }
            if (Array.isArray(value)){
                return true
            }
            else {
                return false
            }
        }
        return false
    },
    hardcode_mode(){
        return this.selectedPath.includes("VALOR FIJO") || this.selectedPath.includes("hardcoded");
    },
    manual_mode(){
        return this.selectedPath.includes("RUTA MANUAL");
    },
    currentDepth(){
        return this.selectedPath.length-1;
    },
    error(){
        if (this.hardcode_mode || this.manual_mode){
            return false
        }
        let value = this.my_bag;
        for(let key of this.selectedPath){
            if (key == ""){
                break;
            }
            if (value ==null || value != null && !Object.keys(value).includes(key)){
                return key;
            }
            value = value[key];
        }
        return null;
    },
  },
  methods: {
    update_value(){
        let val = ''
        if (this.hardcode_mode){
            val = 'hardcoded.'+this.hardcoded_value
        }
        else if (this.manual_mode){
            val = this.hardcoded_value
        }
        else{
            let cleared_path = this.selectedPath.filter( (val) => val != "");
            val =  cleared_path.join(".")
        }
        
        this.$emit("input",val);
        this.$emit("changed_list_situation", this.list_ahead);
    },

    clear_last(){
        this.selectedPath = this.selectedPath.filter( (val) => val != "");
        this.selectedPath = this.selectedPath.slice(0, this.selectedPath.length - 1);
        this.update_value();
        this.go_deeper();
    },
    clear_all(){
        this.hardcoded_value = "";
        this.selectedPath = [];
        this.update_value();
        this.go_deeper();
    },
    selected_route(){
        this.update_value();
        this.go_deeper();
    },
    go_deeper(){
        this.selectedPath = [...this.selectedPath, ""];
    }
  },
  mounted(){
    this.selectedPath = this.value.split(".")
    if (this.selectedPath[0] == "hardcoded"){
        this.hardcoded_value = this.value.split(".").slice(1).join(".")
        this.selectedPath = ['VALOR FIJO'];
    }
    else{
        this.selectedPath = this.selectedPath.filter( (val) => val != "");
        this.go_deeper();
    }
    console.log("Mounted with value ", this.value, " selectedPath ", this.selectedPath);
    this.$emit("changed_list_situation", this.list_ahead);
  }
};
</script>

  
  <style scoped>
  </style>
  